exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-view-header {\n  background-color: #fff;\n  padding: 1.8em 2em 1em;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, .1)\n}\n\n.item-view-header h1 {\n  display: inline;\n  font-size: 1.5em;\n  margin: 0;\n  margin-right: .5em\n}\n\n.item-view-header .meta,\n.item-view-header .meta a {\n  color: #828282\n}\n\n.item-view-header .meta a {\n  text-decoration: underline\n}\n\n.item-view-comments {\n  background-color: #fff;\n  margin-top: 10px;\n  padding: 0 2em .5em\n}\n\n.item-view-comments-header {\n  margin: 0;\n  font-size: 1.1em;\n  padding: 1em 0;\n  position: relative\n}\n\n.item-view-comments-header .spinner {\n  display: inline-block;\n  margin: -15px 0\n}\n\n.comment-children {\n  list-style-type: none;\n  padding: 0;\n  margin: 0\n}\n\n.comment {\n  border-top: 1px solid #eee;\n  position: relative\n}\n\n.comment .by,\n.comment .text {\n  font-size: .9em;\n  margin: 1em 0\n}\n\n.comment .by {\n  color: #828282\n}\n\n.comment .by a {\n  color: #828282;\n  text-decoration: underline\n}\n\n.comment .text {\n  overflow-wrap: break-word\n}\n\n.comment .text a:hover {\n  color: #f60\n}\n\n\n@media (max-width:600px) {\n  .item-view-header h1 {\n    font-size: 1.25em\n  }\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/topic-detail/topic-detail.component.css
// module id = 160
// module chunks = 1